// Mirrors agent/config.ts: localStorage override with a sensible default.
const DEFAULT_CDN = 'https://assets.design.hudak.land';

export function cdnBase(): string {
  if (typeof localStorage !== 'undefined') {
    const o = localStorage.getItem('codeframe.assetCdn');
    if (o) return o;
  }
  return DEFAULT_CDN;
}

/**
 * Base for the authenticated asset API (`/sign`, `/upload`). Defaults to the
 * CDN host — CloudFront forwards `Authorization` to the render Function URL, so
 * a single host works. Override (e.g. to hit the raw Function URL) via
 * localStorage `codeframe.assetApi`.
 */
export function assetApiBase(): string {
  if (typeof localStorage !== 'undefined') {
    const o = localStorage.getItem('codeframe.assetApi');
    if (o) return o;
  }
  return cdnBase();
}

export function uploadUrl(): string {
  if (typeof localStorage !== 'undefined') {
    const o = localStorage.getItem('codeframe.assetUpload');
    if (o) return o;
  }
  return `${assetApiBase()}/upload`;
}
